import { Observable } from 'rxjs';
import { LedgerAccountModel } from '../models/ledger-account.model';
import { ProfitCentresModel } from '../models/profit-centres.model';
import { IBase } from './base-finance.interface';

export interface IJournalPosting extends IBase {
  journalId: number;
  accountId: number;
  profitCenterId?: number;
  description?: string;
  debit: number;
  credit: number;
  order: number;
  currency: string;
  accountAsync: Observable<LedgerAccountModel>;
  profitAsync: Observable<ProfitCentresModel>;
  index?: number;
  chartOfAccount: LedgerAccountModel;
  profitCentres: ProfitCentresModel;
}
